import { DataProvider, fetchUtils } from 'react-admin';
import queryString from 'query-string';

const apiUrl = '/api';
const httpClient = fetchUtils.fetchJson;

const dataProvider: DataProvider = {
	getList: async (resource, params) => {
		const { page, perPage } = params.pagination || { page: 1, perPage: 10 };
		const { field, order } = params.sort || { field: 'id', order: 'ASC' };
		const query = {
			...params.meta,
			sort: JSON.stringify([field, order]),
			range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
			filter: JSON.stringify(params.filter),
		};
		const url = `${apiUrl}/${resource}?${queryString.stringify(query)}`;

		const { headers, json } = await httpClient(url);

		if (!headers.has('content-range')) {
			throw new Error(
				'The Content-Range header is missing in the HTTP Response. The simple REST data provider expects responses for lists of resources to contain this header with the total number of results to build the pagination. If you are using CORS, did you declare Content-Range in the Access-Control-Expose-Headers header?'
			);
		}
		return {
			data: json,
			total: parseInt(headers.get('content-range')?.split('/').pop() || '0', 10),
		};
	},
	
	getOne: async (resource, params) => {
		const query = { ...params.meta };
		const url = `${apiUrl}/${resource}/${params.id}?${queryString.stringify(query)}`;
		const { json } = await httpClient(url);
		return { data: json };
	},
	
	update: async (resource, params) => {
		const query = { ...params.meta };
		const url = `${apiUrl}/${resource}/${params.id}?${queryString.stringify(query)}`;
		const { json } = await httpClient(url, {
			method: 'PUT',
			body: JSON.stringify(params.data),
		});
		return { data: json };
	},
	
	create: async (resource, params) => {
		const query = { ...params.meta };
		const url = `${apiUrl}/${resource}?${queryString.stringify(query)}`;
		const { json } = await httpClient(url, {
			method: 'POST',
			body: JSON.stringify(params.data),
		});
		return { data: json };
	},
	
	delete: async (resource, params) => {
		const query = { ...params.meta };
		const url = `${apiUrl}/${resource}/${params.id}?${queryString.stringify(query)}`;
		await httpClient(url, {
			method: 'DELETE',
		});
		return { data: params.previousData as any };
	},
	
	getMany: async (resource, params) => {
		const query = {
			...params.meta,
			filter: JSON.stringify({ id: params.ids }),
		};
		const url = `${apiUrl}/${resource}?${queryString.stringify(query)}`;
		const { json } = await httpClient(url);
		return { data: json };
	},

	getManyReference: () => Promise.reject('Not implemented'),
	updateMany: () => Promise.reject('Not implemented'),
	deleteMany: () => Promise.reject('Not implemented'),
};

export default dataProvider;
